import { adminUsersStatusSelector } from '../../reducers/user-selectors';
import { createGenericDispatcher } from '../action-dispatcher-factory';

import { UserApiClient } from '../../api/user-api-client';

export const loadAdminUsers = () =>
  createGenericDispatcher({
    name: 'LOAD_ADMIN_USERS',
    loadFunction: UserApiClient.loadAdminUsers,
    args: {},
    shouldExecuteSelector: adminUsersStatusSelector,
  });
